import React, { useEffect, useState } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Webcam from '@uppy/webcam';
import { Dashboard } from '@uppy/react';
import { Modal } from 'rsuite';
import { AppConfig } from '../../../helpers/config';
import uppyAwsS3Upload from '../../../helpers/uppyAwsS3Upload';
import { createFilename } from '../../../helpers/guestProfilePhoto';
import { StringOrNumberType } from '../../../interfaces';

import '@uppy/webcam/dist/style.min.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@uppy/dashboard/dist/style.min.css';

const StyledModal = styled(Modal)`
  &.rs-modal {
    width: 620px;
  }
`;

const UppyDashboardWrapper = styled.div`
  .uppy-DashboardItem {
    float: none;
    width: 280px;
    height: 215px;
    margin: 0 auto;
  }
  .uppy-DashboardItem-preview {
    height: 100%;
  }
`;

const uppyDashboardProps = {
  plugins: ['Webcam'],
  allowMultipleUploads: false,
  proudlyDisplayPoweredByUppy: false,
  locale: {
    strings: {
      dropHereOr: 'Drop File or %{browse}',
      uploadXFiles: { 0: 'Upload photo' },
      xFilesSelected: { 0: 'Selected Photo' },
      uploadingXFiles: { 0: 'Uploading Photo' },
      processingXFiles: { 0: 'Processing Photo' }
    }
  },
  note: 'Accepted image is up to 1 MB only'
};

const UploadPhotoModal = ({ show, guestId, onHide, onComplete, ...props }) => {
  const [uppy, setUppy] = useState(null);

  useEffect(
    () => {
      if (!guestId) return;
      if (!uppy) {
        setUppy(
          uppyAwsS3Upload({
            autoProceed: true,
            filename: createFilename(guestId),
            fixedFilename: true,
            bucket: fp.get('buckets.images', AppConfig)
          }).use(Webcam, {
            modes: ['picture'],
            showVideoSourceDropdown: true,
            mirror: false
          })
        );
      } else {
        uppy.on('complete', () => {
          uppy.reset();
          onComplete(new Date().getUTCMilliseconds());
        });
      }
    },
    [uppy, guestId]
  );

  return (
    <StyledModal overflow show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Guest Profile Photo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UppyDashboardWrapper {...props}>
          {uppy && <Dashboard uppy={uppy} {...uppyDashboardProps} />}
        </UppyDashboardWrapper>
      </Modal.Body>
    </StyledModal>
  );
};

UploadPhotoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  guestId: StringOrNumberType.isRequired,
  onHide: PropTypes.func,
  onComplete: PropTypes.func
};

UploadPhotoModal.defaultProps = {
  onHide: () => {},
  onComplete: () => {}
};

export default UploadPhotoModal;
